import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';

import VariableType from 'app/admin/piWriter/dto/VariableType';
import PiWriterEditService from '../service/PiWriterEditService';
import PiWriterLogService from 'app/admin/piWriterLog/service/PiWriterLogService';
import UserGroupService from 'app/admin/userGroup/service/UserGroupService';

const config = data => {
	return {
		key: 'piWriterEditForm',
		topic: 'piWriter',
		service: PiWriterEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'userGroup',
					component: EditFormSelectField,
					// multiple: true,
					items: () => UserGroupService.getListSelection()
				},
				{
					key: 'hostname',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'dataServerName',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'user',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'password',
					type: 'password',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'timezone',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'piWriterLog',
					component: EditFormSelectField,
					required: true,
					items: () => PiWriterLogService.getListSelection()
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						name: null,
						type: null,
						tagName: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(VariableType).map(key => { return { label: VariableType[key], value: key }; })
						},
						{
							key: 'tagName',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'expression',
							component: EditFormTextField,
							dependsOn: 'type',
							required: true,
							visibleIf: type => type === 'Expression'
						}
					]
				}
			];

			return fields;
		}
	};
};

function PiWriterEditForm() {
	const { id } = useParams();
	const myConfig = config({ id });

	return (
		<EditFormPage config={myConfig} />
	);
}

export default withRouter(PiWriterEditForm);